export default "__VITE_PUBLIC_ASSET__a461d6b2__"